import React, { useState, useEffect } from 'react';
import 'tailwindcss/tailwind.css';
import AuthWrapper from '../Comp/AuthWrapper';
import AddCar from '../Comp/AddCar';
import EditCar from '../Comp/EditCar';
import { apiFetch } from '../utils/Api';
import { useNavigate } from 'react-router-dom';

const AdminPage = () => {
  const [cars, setCars] = useState([]);
  const [editingCar, setEditingCar] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCars();
  }, []);

  const fetchCars = async () => {
    try {
      const response = await apiFetch('/api/cars');
      setCars(response);
    } catch (error) {
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Weet u zeker dat u deze auto wilt verwijderen?')) {
      try {
        await apiFetch(`/api/cars/${id}`, {
          method: 'DELETE'
        });
        
        await fetchCars();
      } catch (error) {
        alert('Error bij verwijderen auto: ' + error.message);
      }
    }
  };

  const handleImageUpload = async (carId, files) => {
    try {
      const formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append('files', files[i]);
      }

      const token = localStorage.getItem('token');
      
      const response = await fetch(`https://s-backend-rebuild-production.up.railway.app/api/FileUpload/upload/${carId}`, {
        method: 'POST',
        body: formData,
        headers: token ? {
          'Authorization': `Bearer ${token}`
        } : undefined
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      alert('Afbeeldingen succesvol geüpload!');
      await fetchCars();
    } catch (error) {
      alert('Error bij uploaden afbeeldingen: ' + error.message);
    }
  };

  const handleDeleteImage = async (carId, imageUrl) => {
    if (window.confirm('Weet u zeker dat u deze afbeelding wilt verwijderen?')) {
      try {
        const fileName = imageUrl.split('/').pop();

        await apiFetch(`/api/FileUpload/delete/${carId}/${encodeURIComponent(fileName)}`, {
          method: 'DELETE'
        });

        await fetchCars();
      } catch (error) {
        alert('Error bij verwijderen afbeelding: ' + error.message);
      }
    }
  };

  const handleCarClick = (carId) => {
    navigate(`/product/${carId}`);
  };

  return (
    <AuthWrapper>
      <div className="min-h-screen bg-gray-100 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Auto Beheer</h1>
            <AddCar onCarAdded={fetchCars} />
          </div>

          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Auto</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Uitvoering</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Afbeeldingen</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Prijs</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Acties</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {cars.map((car) => (
                  <tr key={car.id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div
                        onClick={() => handleCarClick(car.id)}
                        className="font-medium text-gray-900 hover:text-blue-600 cursor-pointer transition-colors duration-200"
                      >
                        {car.merk} {car.model}
                      </div>
                      <div className="text-sm text-gray-500">{car.kenteken}</div>
                      <div className="text-sm text-gray-500">{car.uitvoering}</div>
                    </td>
                    <td className="px-6 py-4">
                      {car.imageLinks && car.imageLinks.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                          {car.imageLinks.map((imageUrl, index) => (
                            <div key={index} className="relative">
                              <img
                                src={`https://s-backend-rebuild-production.up.railway.app/${imageUrl.replace(/^\/+/, '')}`}
                                alt={`${car.merk} ${car.model}`}
                                className="w-20 h-20 object-cover rounded-md"
                                onClick={() => setSelectedImage(imageUrl)}
                              />
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteImage(car.id, imageUrl);
                                }}
                                className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center 
                                         hover:bg-red-600 transition-colors duration-200 text-sm"
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="text-sm text-gray-500 italic">Geen afbeeldingen</div>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-sm font-medium text-gray-900">€{car.prijs}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center space-x-2">
                        <button
                          onClick={() => setEditingCar(car)}
                          className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-1 rounded text-sm transition duration-200"
                        >
                          Bewerken
                        </button>
                        <label className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm transition duration-200 cursor-pointer">
                          Upload Afbeeldingen
                          <input
                            type="file"
                            multiple
                            className="hidden"
                            onChange={(e) => handleImageUpload(car.id, e.target.files)}
                            accept="image/*"
                          />
                        </label>
                        <button
                          onClick={() => handleDelete(car.id)}
                          className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm transition duration-200"
                        >
                          Verwijderen
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {editingCar && (
          <EditCar
            car={editingCar}
            onClose={() => setEditingCar(null)}
            onUpdate={fetchCars}
          />
        )}

        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative w-[800px] h-[600px]">
              <img
                src={`https://s-backend-rebuild-production.up.railway.app/${selectedImage}`}
                alt="Geselecteerde auto"
                className="w-full h-full object-contain"
                onClick={e => e.stopPropagation()}
              />
              <button
                className="absolute top-4 right-4 text-white bg-red-500 hover:bg-red-600 rounded-full w-10 h-10 
                           flex items-center justify-center text-xl transition-colors duration-200"
                onClick={() => setSelectedImage(null)}
              >
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </AuthWrapper>
  );
};

export default AdminPage;